import React, { useState, useEffect, useRef } from 'react';
import '../index.css';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext.js';
import { useProperty } from '../context/PropertyContext.js';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useNotification } from '../context/NotificationContext.js';

const EditPersonalPropertiesModal = ({ isOpen, onClose, property }) => {
  const serverUrl = 'https://osdevhub.com/homify_backend/api/properties';
  

  

  const {updateOneProperty, fetchMyProperties, propertyIsLoading} = useProperty()

  const {postNotification} = useNotification();

    const navigate = useNavigate();
    const {user} = useAuth();
    const user_id = user.id

  const [formData, setFormData] = useState({
    name_of_property: property.name_of_property || '',
    address: property.address || '',
    price: property.price || '',
    type_of_property: property.type_of_property || '',
    transaction: property.transaction || '',
    no_bedroom: property.no_bedroom || '',
    no_bathroom: property.no_bathroom || '',
    house_area: property.house_area || '',
    image: null,
    existing_image: property.image || '',
    user_id: user_id,
    description: property.description || ''

  });

  useEffect(() => {
    if (property) {
      setFormData({
        name_of_property: property.name_of_property || '',
        address: property.address || '',
        price: property.price || '',
        type_of_property: property.type_of_property || '',
        transaction: property.transaction || '',
        no_bedroom: property.no_bedroom || '',
        no_bathroom: property.no_bathroom || '',
        house_area: property.house_area || '',
        image: null,
        existing_image: property.image || '',
        user_id: user_id,
        description: property.description || ''
      });
    }
  }, [property, user_id]);

  const [error, setError] = useState(null);
  const modalRef = useRef(null);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value
    }));
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
 
  
      setFormData((prevData) => ({
        ...prevData,
        image: file
      }));
  };

  const handleSave = async () => {
    const data = new FormData();
    Object.entries(formData).forEach(([key, value]) => {
      if (key !== 'image') {
        
        data.append(key, value);
      }
    });

    if (formData.image instanceof File) {
      alert(434)
      console.log('checking what we want to append', formData.image);
      
      data.append('image', formData.image);
    }

    try {
      await updateOneProperty(property.id, data);
      await fetchMyProperties(user_id);

      
              toast.success('Property was updated successfully', {
                position: "top-right",
                autoClose: 800
            });
      
              setTimeout(() => {
                onClose();
              }, 3000)

              
        const notifyData ={
          message: `You just successfully updated your property '${formData.name_of_property}' `,
          type: 'personal',
          user_id: user.id,
          sender_id: user.id,
          url: `/dashboard/myproperties`
        }

        await postNotification(notifyData)
    } catch (err) {
      console.error("Update error:", err);
      setError("Failed to update property.");
    }
  };

  

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  

  return (
    <div className="modal-container">
      <ToastContainer />
      <div className="userdata-modal-content" ref={modalRef}>
        <div className="add-text-header">
          <h3>Edit Property</h3>
          <span onClick={onClose} className="close">&times;</span>
        </div>
        <div id="user-data-content-container-location" className="margin-top">
          <form className="biodata-form">
            <div className="three-forms">
              <div className="form_element">
                <label className="form-label" htmlFor="name_of_property">Name of Property</label>
                <input
                  className="modal-input"
                  type="text"
                  id="name_of_property"
                  name="name_of_property"
                  value={formData.name_of_property}
                  onChange={handleChange}
                />
              </div>
              <div className="form_element">
                <label className="form-label" htmlFor="address">Address</label>
                <input
                  className="modal-input"
                  type="text"
                  id="address"
                  name="address"
                  value={formData.address}
                  onChange={handleChange}
                />
              </div>
              <div className="form_element">
                <label className="form-label" htmlFor="price">Price</label>
                <input
                  className="modal-input"
                  type="number"
                  id="price"
                  name="price"
                  value={formData.price}
                  onChange={handleChange}
                />
              </div>
            </div>
            <div className="three-forms">
              <div className="form_element">
                <label className="form-label" htmlFor="image">Image</label>
                <input
                  className="modal-input"
                  type="file"
                  id="image"
                  name="image"
                  onChange={handleFileChange} // Use the new handler for file input
                />
              </div>
              <div className="form_element">
                <label className="form-label" htmlFor="type_of_property">Type of Property</label>
              <select
                   className="modal-input"
                  id="type_of_property"
                  name="type_of_property"
                  value={formData.type_of_property}
                  onChange={handleChange}
                >
                  <option value="">Select a type of property</option>
                  <option value="Residential Building">Residential Building</option>
                  <option value="Commercial Building">Commercial Building</option>
                  <option value="Land">Land</option>
                </select>
          
              </div>
          
              <div className="form_element">
                <label className="form-label" htmlFor="transaction">Transaction Type</label>
                <select
                  className="modal-input"
                  id="transaction"
                  name="transaction"
                  value={formData.transaction}
                  onChange={handleChange}
                >
                  <option value="">Select Transaction</option>
                  <option value="Sale">Sale</option>
                  <option value="Rent">Rent</option>
                </select>
              </div>
            </div>
            <div className="three-forms">
              <div className="form_element">
                <label className="form-label" htmlFor="no_bedroom">Bedrooms</label>
                <input
                  className="modal-input"
                  type="number"
                  id="no_bedroom"
                  name="no_bedroom"
                  value={formData.no_bedroom}
                  onChange={handleChange}
                />
              </div>
              <div className="form_element">
                <label className="form-label" htmlFor="no_bathroom">Bathrooms</label>
                <input
                  className="modal-input"
                  type="number"
                  id="no_bathroom"
                  name="no_bathroom"
                  value={formData.no_bathroom}
                  onChange={handleChange}
                />
              </div>
              <div className="form_element">
                <label className="form-label" htmlFor="house_area">House Area (sq ft)</label>
                <input
                  className="modal-input"
                  type="number"
                  id="house_area"
                  name="house_area"
                  value={formData.house_area}
                  onChange={handleChange}
                />
              </div>
                  
            </div>
              <div className="form_element">
                <label className="form-label" htmlFor="description">Description</label>
                <textarea 
                  className="modal-textarea"
                  id="description"
                  name="description"
                  rows='4'
                  value={formData.description}
                  onChange={handleChange} placeholder="Please, describe the property" />
              </div>
       
            {error && <p className="error-message">{error}</p>}
            <div className="modal-button-container margin-bottom">
              <button type="button" className="generate-button" onClick={handleSave}>
                {
                  propertyIsLoading ? 'Updating...' : 'Update'
                }
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default EditPersonalPropertiesModal;
